// extracted by mini-css-extract-plugin
export default {"ulysse-prefix":"input_ulysse-prefix__5HMAx","typeNumber":"input_typeNumber__zlyXw"};